import * as React from 'react';
import { useToastTitle_unstable } from './useToastTitle';
import { renderToastTitle_unstable } from './renderToastTitle';
import { useToastTitleStyles_unstable } from './useToastTitleStyles.styles';
import { useCustomStyleHook_unstable } from '@fluentui/react-shared-contexts';
/**
 * ToastTitle component
 */ export const ToastTitle = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const state = useToastTitle_unstable(props, ref);
    useToastTitleStyles_unstable(state);
    useCustomStyleHook_unstable('useToastTitleStyles_unstable')(state);
    return renderToastTitle_unstable(state);
});
ToastTitle.displayName = 'ToastTitle';
